import React from "react";
import { Container, LoadingContainer } from "./styles";
import DotLoader from "react-spinners/ClipLoader";

type Props = {
  text: string;
  loading: boolean;
  onClick?: () => void;
};
const Button = ({ text, loading, onClick }: Props) => {
  if (loading) {
    return (
      <LoadingContainer>
        <DotLoader size={50} color={"#9a4749"} loading={loading} speedMultiplier={1.5} />
      </LoadingContainer>
    );
  }

  return <Container onClick={onClick}>{text}</Container>;
};

export default Button;
